/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.library").
controller("DxExamLibraryController", function ExamLibraryController(
	$filter,
	$scope,

	dxApi,
	DX_URLS,

	localStorageService
) {
	"use strict";

	var self = this;

	$scope.Urls = DX_URLS;

	$scope.examTemplates = [];
	$scope.selectedQuestionIds = [];

	$scope.sortingOptions = {
		title: {
			order: "title",
			i18n: "Title",
		},
		subject: {
			order: "subject",
			i18n: "Subject",
		},
		modified: {
			order: "-modified",
			i18n: "LastModified",
		},
		created: {
			order: "-created",
			i18n: "LastCreated",
		},
	};

	var localStorageSortingKey = "library.exam.sort";

	$scope.searchQuery = "";
	$scope.sortOrder = localStorageService.get(localStorageSortingKey) || $scope.sortingOptions.title;

	$scope.searchFilter = function searchFilter(exam) {
		if (!$scope.searchQuery) {
			return true;
		}

		var formattedExamAt = $filter("date")(exam.at, "yyyy-MM-dd");
		var searchString = [exam.title, exam.subject, formattedExamAt].join(" # ");

		return searchString.toLowerCase().indexOf($scope.searchQuery.toLowerCase()) !== -1;
	};

	$scope.setSortOrder = function setSortOrder(sortingOption) {
		$scope.sortOrder = sortingOption;
		return localStorageService.set(localStorageSortingKey, sortingOption);
	};

	$scope.getExamTemplates = function getExamTemplates() {
		dxApi.v1.examTemplates.get().then(onGetExamTemplates);
	};

	function onGetExamTemplates(res) {
		$scope.examTemplates = res.data;
		$scope.examTemplatesLoaded = true;
	}

	self.questionSelected = function questionSelected(questionId) {
		return $scope.selectedQuestionIds.indexOf(questionId) !== -1;
	};

	function updateQuestionSelection(questionId, selected) {
		var indexOf = $scope.selectedQuestionIds.indexOf(questionId);

		if (selected && indexOf === -1) {
			$scope.selectedQuestionIds.push(questionId);
		} else if (!selected && indexOf !== -1) {
			$scope.selectedQuestionIds.splice(indexOf, 1);
		}
	}

	self.setQuestionSelected = function setQuestionSelected(questionId, selected) {
		updateQuestionSelection(questionId, selected);
		$scope.$broadcast("DxExamLibraryController:questionsSelectedUpdated", $scope.selectedQuestionIds);
	};

	self.setExamSelected = function setExamSelected(examTemplateId, selected, broadcast) {
		var examTemplateArr = $scope.examTemplates.filter(function examTemplateById(element) {
			return element.id === examTemplateId;
		});

		if (examTemplateArr.length !== 1) {
			return;
		}

		var examTemplate = examTemplateArr[0];

		for (var i = 0; i < examTemplate.questions.length; i++) {
			updateQuestionSelection(examTemplate.questions[i].id, selected);
		}

		if (broadcast) {
			$scope.$broadcast("DxExamLibraryController:questionsSelectedUpdated", $scope.selectedQuestionIds);
		}
	};

	$scope.addSelectedQuestionsToExam = function addSelectedQuestionsToExam() {
		var filteredExamTemplates = $filter("filter")($scope.examTemplates, $scope.searchFilter);
		var filteredAndSortedExamTemplates = $filter("orderBy")(filteredExamTemplates, $scope.sortOrder.order);

		function copySelected(question) {
			if ($scope.selectedQuestionIds.indexOf(question.id) !== -1) {
				$scope.exam.copyQuestion(question);
			}
		}

		for (var i = 0; i < filteredAndSortedExamTemplates.length; i++) {
			filteredAndSortedExamTemplates[i].questions.forEach(copySelected);
		}

		$scope.selectedQuestionIds = [];

		$scope.$broadcast("DxExamLibraryController:questionsSelectedUpdated", $scope.selectedQuestionIds);
	};

	$scope.$on("CreateExamController:examTemplateSaved", function addSavedExamTemplate(event, exam) {
		for (var i = 0; i < $scope.examTemplates.length; i++) {
			if ($scope.examTemplates[i].id === exam.id) {
				$scope.examTemplates[i] = angular.copy(exam);
				return;
			}
		}

		var newExam = angular.copy(exam);
		$scope.examTemplates.push(newExam);
	});

	$scope.getExamTemplates();
});
